export default __webpack_public_path__ + "static/media/mexico.e8b44555.jpg";